import { render, staticRenderFns } from "./tagsList.vue?vue&type=template&id=c3d7b2c0&"
import script from "./tagsList.vue?vue&type=script&lang=js&"
export * from "./tagsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports